<form [formGroup]="form" (ngSubmit)="onSubmit(form)" validate>
    <div class="form-group" [hidden]="hideLookup">
        <label for="lookupType" >Select {{lookupLabel}}</label>
        <select class="form-control form-control-sm" formControlName="LookupType">
            <option [defaultSelected]=true value="0" disabled>Select One</option>
            <option *ngFor="let opt of lookupTypes" [ngValue]="opt.Value">{{opt.Label}}</option>
        </select>
        <div *ngIf="form.controls['LookupType'].invalid && form.controls['LookupType'].touched" class="error">
            *Please select a valid {{lookupLabel}}.
        </div>
    </div>

    <label for="comment">Comment</label>
    <editor [apiKey]="tinyKey" [init]="tinyInitOptions" formControlName="Comment" [disabled]="isReadOnly()" (appFocusAutosave)="autosave(form)">
    </editor>
    <div class="text-center">
        <span *ngIf="!form.valid || doesFormNeedSaved(form)" class="text-secondary">Unsaved</span>
        <span *ngIf="form.valid && !doesFormNeedSaved(form)" class="text-success">Saved</span>
    </div>

    <div *ngIf="form.controls['Comment'].invalid && form.controls['Comment'].touched" class="error">
        *Field cannot be empty.
    </div>
    <ul class="list-group list-group-flush">
        <li class="list-group-item" *ngFor="let file of attachments">
          <button type="button" class="btn btn-info mr-3"  (click)="deleteAttachement(file)"> <i class="fas fa-trash-alt" style="color: #ba1717;"></i></button>
          <i class="fas fa-paperclip"></i>
            <a href="Javascript://" (click)="viewAttachement(file)"> {{ file.fileName }}</a>
        </li>
    </ul>
    <div class="d-flex flex-row justify-content-between">
        <div class="text-left">
            <button type="button" class="btn btn-secondary m-2 attach-button" *ngIf="!isReadOnly()"
                (click)="onAttachComment()">+ Attach File</button>
        </div>
        <div class="text-right">
            <button type="button" class="btn btn-secondary m-2 save-button" [disabled]="!isFormValid()" *ngIf="!isReadOnly()"
                (click)="onSubmit(form)"><i class="far fa-save"></i> Save Comment</button>
            <button type="button" class="btn btn-primary m-2 publish-button" [disabled]="!isFormValid()"
                *ngIf="!isReadOnly() && (!comment || comment.commentState == CommentState.DRAFT)" (click)="onSubmit(form, true)"><i
                class="fas fa-plus"></i> Publish Comment</button>
            <button type="button" class="btn btn-info m-2 cancel-button" (click)="onCancelClicked()">Close</button>
        </div>

    </div>
</form>

